
import {Swiper, SwiperSlide} from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
  name: "PopUpImages",

  computed: {
    isOpen: function () {
      return this.$store.state["pop-up-video"]?.isOpen || false
    },
    videoLink: function () {
      return this.$store?.state?.["pop-up-video"]?.videoLink || ""
    },
    videoTitle: function () {
      return this.$store?.state?.["pop-up-video"]?.videoTitle || ""
    },
    videoTitle: function () {
      return this.$store?.state?.["pop-up-video"]?.videoTitle || ""
    },
  },

  components: {
    Swiper,
    SwiperSlide
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        document.body.style.overflow = "hidden";
        return
      }

      document.body.style = "";
    }
  },

  methods: {
    onClose: function () {
      this.$store.commit("pop-up-video/closePopUp")
    }
  }
}
